<template>
	<div class="card flex justify-content-center relative" style="max-height: 350px; overflow-y: auto;">
		<div class="card-body w-full">
			<div class="flex gap-2 flex-col">
				<div class="flex justify-content-center items-center bg-gray-100 p-2 rounded-lg shadow">
					<div class="flex text-xs items-center mb-1">
						<div class="flex items-center">
							<i class="tabler:question-circle text-md inline-flex mr-2"></i>Question
						</div>
					</div>

					<EwTextarea
						ref="questionInput"
						class="min-w-[300px] flex-1"
						placeholder="Question"
						v-model="content.question"
						:clearable="false"
						:rows="3"
						:disabled="props.disabled"
					>
					</EwTextarea>
				</div>
				<div v-for="(answer, index) in content.answers" :key="index" >
					<div class="flex flex-col gap-2 w-full">
						<div class="bg-gray-100 p-2 rounded-lg shadow">
							<div class="flex text-xs items-center mb-1">
								<div class="flex items-center">
									<i class="tabler:question-circle text-md inline-flex mr-2"></i>Options
								</div>
								<div class="flex items-center ml-auto">
									<span class="mr-2">Is Correct?</span>
									<InputSwitch v-model="answer.isCorrect" class=""/>
								</div>

							</div>
							<div class="flex-1 flex gap-2">
								<div class="w-25">
									<EwInput
										ref="answerInput"
										placeholder="Question"
										:clearable="false"
										v-model="answer.answerLabel"
										:disabled="props.disabled"
									>
									</EwInput>
								</div>
								<div class="flex-1">
									<EwInput
										ref="answerInput"
										placeholder="Option"
										class="flex-1"
										:clearable="false"
										v-model="answer.answer"
										:disabled="props.disabled"
									>
										<template #prepend>
											<div class="ew-input-group-text">
												Option
											</div>
										</template>
									</EwInput>
								</div>
							</div>
						</div>
						<div class="bg-white border p-2 shadow rounded-lg ml-3">
							<div class="flex text-xs items-center mb-1">
								<div class="flex items-center">
									<i class="tabler:message text-md inline-flex mr-2"></i>Feedback
								</div>
							</div>

							
							<EwTextarea
								ref="answerInput"
								class="min-w-[300px]"
								placeholder="Answer feedback"
								v-model="answer.explanation"
								:disabled="props.disabled"
							>
								<template #prepend>
									<div class="ew-input-group-text">
										Reason
									</div>
								</template>
							</EwTextarea>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script setup lang="ts">
import { EwInput, EwTextarea } from '@arkit/ew-vue-components';
import type { QuizQuestionsItem } from '@/types';
import InputSwitch from 'primevue/inputswitch';


const props = withDefaults(defineProps<{
	disabled?: boolean;
}>(), {
	disabled: false,
});

const content = defineModel<QuizQuestionsItem>('modelValue', { required: true })


const internalContent = computed({
	get: ()=> content.value,
	set: (value)=> {
		console.log(value)
		//content.value = value
	}

})

</script>
<style scoped>
.p-inputswitch .p-inputswitch-slider{
	border-radius: 10px!important;
	height: 21px!important;
}
.p-inputswitch .p-inputswitch-slider:before{
	width: 0.8rem!important;
    height: 0.8rem!important;
}
</style>
